import { render, staticRenderFns } from "./DeleteFarm.vue?vue&type=template&id=344ac260&lang=html&"
import script from "./DeleteFarm.vue?vue&type=script&lang=js&"
export * from "./DeleteFarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports